var $ = jQuery.noConflict();
$(document).ready(function() {
    
    $('.check_postcode_form input').on('input', function () {
        this.value = this.value.replace(/[^0-9]/g, '');

        if (this.value.length === 4) {
            $('.check_postcode_form a').removeClass('disable');
        } else {
            $('.check_postcode_form a').addClass('disable');
        }
    });

    $('.check_postcode_form a').on('click', function(e){
        e.preventDefault();

        var input_val = $('.check_postcode_form input').val().trim();
        var result = lookupPostcode(input_val);

        if (result.serviceable && !result.outofstock) {
            $('.step_location').removeClass('hidden');
            checkQLD();
        } else if (result.outofstock) {
            $('.step_outofstock').removeClass('hidden');
            $('.step_outofstock p.title span').html(input_val);
            $('.step_outofstock .postcode_note span').html(input_val);

            checkFieldsStepOutOfStock();
        } else {
            // $('.step_location').removeClass('hidden');
            $('.step_outside_installation').removeClass('hidden');
            $('.step_outside_installation p.title span').html(input_val);
            $('.step_outside_installation .postcode_note span').html(input_val);

            checkFieldsStepOutsideInstallation();
        }

        $('.start_check_postocde').addClass('hidden');
    });

    $('.property_container .selection a').on('click', function(e){
        e.preventDefault();

        $('.property_container .selection a').removeClass('active');
        $(this).addClass('active');

        var sel_property = $(this).data('value');

        $('.property_container .note_wrapper .note_container').addClass('hidden');
        $('.property_container .note_wrapper .note_container.'+sel_property.toLowerCase()).removeClass('hidden');

        if( sel_property == 'House'){
            $('.step_location .button_container a.see_batteries').removeClass('hidden');
            $('.step_location .button_container a.continue').addClass('hidden');
        } else {
            $('.step_location .button_container a.see_batteries').addClass('hidden');
            $('.step_location .button_container a.continue').removeClass('hidden');
            $('.step_location .button_container a.continue.unserviceable').addClass('hidden');
        }
        
        checkLocation();
        checkQLD();

    });

    $('.power_container .selection a').on('click', function(e){
        e.preventDefault();

        $('.power_container .selection a').removeClass('active');
        $(this).addClass('active');

        var sel_property = $(this).data('value');

        $('.power_container .note_wrapper .note_container').addClass('hidden');
        $('.power_container .note_wrapper .note_container.'+sel_property.toLowerCase().replace(" ","_")).removeClass('hidden');

        
        checkLocation();
        checkQLD();
    });

    $('.solar_panel_container .selection a').on('click', function(e){
        e.preventDefault();

        $('.solar_panel_container .selection a').removeClass('active');
        $(this).addClass('active');

        var sel_property = $(this).data('value');

        $('.solar_panel_container .note_wrapper .bottom_note').addClass('hidden');
        $('.solar_panel_container .note_wrapper .bottom_note.solar_panel_'+sel_property.toLowerCase()).removeClass('hidden');

        
        checkLocation();
        checkQLD();
    });

    $('.step_location .button_container a.back').on('click', function(e){
        e.preventDefault();

        $('.step_location').addClass('hidden');
        $('.start_check_postocde').removeClass('hidden');
    })

    $('.step_location .button_container a.see_batteries').on('click', function(e){
        e.preventDefault();
        
        $('.step_location').addClass('hidden');
        $('.step_battery').removeClass('hidden');

        var power = $('.step_location .power_container .selection a.active').data('value');
        if( power == 'Not sure'){
            power = 'Single-phase';
        }
        var input_val = $('.check_postcode_wrapper .check_postcode_form input').val();
        var result = lookupPostcode(input_val);

        var state = result.state.toLowerCase();

        $('.step_battery .battery_content_wrapper .battery_container').each(function () {

            var isState = $(this).data(state) === true || $(this).data(state) === "true";
            var isPower = $(this).data('power') === power;

            if (isState && isPower) {
                $(this).removeClass('hidden');
            } else {
                $(this).addClass('hidden');
            }
        });

        var score = calcConfidence();

        $('.confident_container .rating .rating_percent span').html(score+'%');
        $('.confident_container .content p strong span').html(score);

        const radius = 32;
        const circumference = 2 * Math.PI * radius;
        const offset = circumference - (score / 100) * circumference;

        $('.confident_container .rating .rating_bg svg circle').eq(1).css('stroke-dashoffset', offset);

        checkFieldsStepInstallation();
        
    });

    $('.step_location .button_container a.continue.unserviceable').on('click', function(e){
        e.preventDefault();

        $('.step_location').addClass('hidden');

        var input_val = $('.check_postcode_form input').val().trim();

        $('.step_outside_installation').removeClass('hidden');
        $('.step_outside_installation p.title span').html(input_val);
        $('.step_outside_installation .postcode_note span').html(input_val);

        checkFieldsStepOutsideInstallation();

        // e.preventDefault();

        // var input_val = $('.check_postcode_form input').val().trim();
        // var result = lookupPostcode(input_val);

        // if (result.serviceable) {
        //     $('.step_location').removeClass('hidden');
        //     checkQLD();
        // } else {
        //     // $('.step_location').removeClass('hidden');
        //     $('.step_outside_installation').removeClass('hidden');
        //     $('.step_outside_installation p.title span').html(input_val);
        //     $('.step_outside_installation .postcode_note span').html(input_val);

        //     checkFieldsStepOutsideInstallation();
        // }

        // $('.start_check_postocde').addClass('hidden');
    });

    $('.step_location .button_container a.continue:not(.unserviceable)').on('click', function(e){
        e.preventDefault();

        $('.step_specialist_enquiry').removeClass('hidden');
        $('.step_location').addClass('hidden');

        var sel_property = $('.step_location .property_container .selection a.active').data('value');
        var sel_solar = $('.step_location .solar_panel_container .selection a.active').data('value');
        
         if( sel_solar == 'Yes'){
            sel_solar = 'existing'
        } else if( sel_solar == 'No'){
            sel_solar = 'no existing'
        } else if( sel_solar == 'Planning to add'){
            sel_solar = sel_solar
        }
        
        var sel_power = $('.step_location .power_container .selection a.active').data('value');
        if( sel_power == 'Not sure'){
            sel_power = 'phase to be confirmed';
        } else {
            sel_power = sel_power + ' power';
        }

        var sel_postcode = $('.check_postcode_form input').val().trim();

        $('.step_specialist_enquiry .postcode_note .n_property').html(sel_property.toLowerCase());
        $('.step_specialist_enquiry .postcode_note .n_phase').html(sel_power.toLowerCase());
        $('.step_specialist_enquiry .postcode_note .n_solar').html(sel_solar.toLowerCase());
        $('.step_specialist_enquiry .postcode_note .n_postcode').html(sel_postcode);
        
        $('.step_location').addClass('hidden');

        checkFieldsSpecialEnquiry();
    });

    $('.battery_content_wrapper .battery_container').on('click', function(e){
        e.preventDefault();

        $('.battery_content_wrapper .battery_container').removeClass('selected');
        $(this).addClass('selected');

        $('.step_battery .button_container a.continue').removeClass('disable');
    });

    $('.step_battery .button_container a.back').on('click', function(e){
        e.preventDefault();

        $('.step_battery').addClass('hidden');
        $('.step_location').removeClass('hidden');

        $('.step_battery .battery_content_wrapper .battery_container').removeClass('selected');
        $('.step_battery .button_container a.continue').addClass('disable');
    })

    $('.step_battery .button_container a.continue').on('click', function(e){
        e.preventDefault();

        $('.step_battery').addClass('hidden');
        $('.step_installation').removeClass('hidden');

        checkFieldsStepInstallation();
    });

    $('.step_outside_installation .button_container .back').on('click', function(e){
        e.preventDefault();

        $('.step_outside_installation').addClass('hidden');
        $('.start_check_postocde').removeClass('hidden');
    });

    $('.step_outside_installation .button_container .continue').on('click', function(e){
        e.preventDefault();
        
        submitHubspotForm();

        $('.step_outside_installation').addClass('hidden');
        $('.step_thank_you').removeClass('hidden');

    });

    $('.step_outofstock  .button_container .back').on('click', function(e){
        e.preventDefault();

        $('.step_outofstock ').addClass('hidden');
        $('.start_check_postocde').removeClass('hidden');
    });

    $('.step_outofstock .button_container .continue').on('click', function(e){
        e.preventDefault();
        
        submitHubspotForm();

        $('.step_outofstock').addClass('hidden');
        $('.step_thank_you').removeClass('hidden');

    });

    $('.step_installation .button_container .back').on('click', function(e){
        e.preventDefault();

        $('.step_installation').addClass('hidden');
        $('.step_battery').removeClass('hidden');
    });

    $('.step_installation .button_container .continue').on('click', function(e){
        e.preventDefault();

        $('.step_installation').addClass('hidden');
        $('.step_payment').removeClass('hidden');

        

        var name_product = $('.step_battery .battery_content_wrapper .battery_container.selected .capacity_kwh .name_product').html();
        var name_capacity = $('.step_battery .battery_content_wrapper .battery_container.selected .capacity_kwh .name_capacity').html();
        var name_inverter = $('.step_battery .battery_content_wrapper .battery_container.selected .capacity_kwh .name_inverter').html();
        var name_ac_hybrid = $('.step_battery .battery_content_wrapper .battery_container.selected .capacity_kwh .ac_hybrid').html();
        var price = $('.step_battery .battery_content_wrapper .battery_container.selected .price_container .discounted_price').html();
        var precentage = $('.step_battery .confident_container .rating .rating_percent span').html();

        var balance = ( (parseFloat(price.replace(/[^0-9.]/g, ''))) - 249 );

        var balance_formatted = balance.toLocaleString('en-AU', {
            style: 'currency',
            currency: 'AUD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });

        // $('.payment_wrapper .order_summary .product_title').html(name_product.trim()+' '+name_capacity.trim()+' '+(name_ac_hybrid || '').trim());
        $('.payment_wrapper .order_summary .product_title .name_data').html(name_product.trim()+' ');
        $('.payment_wrapper .order_summary .product_title .capacity_data').html(name_capacity.trim()+' ');
        $('.payment_wrapper .order_summary .product_title .ac_hybrid_data').html( (name_ac_hybrid || '').trim() );
        $('.payment_wrapper .order_summary .product_details .inverter_data').html(name_inverter.trim());
        $('.payment_wrapper .order_summary .break_down.fist .amount').html(price.trim());
        $('.payment_wrapper .order_summary .total .amount').html(price.trim());
        $('.payment_wrapper .order_summary .total .amount').html(price.trim());
        $('.payment_wrapper .confidence .rating').html(precentage.trim());
        $('.payment_wrapper .confidence .content span').html(precentage.trim());
        $('.payment_wrapper .payment_method .label span.balance').html(balance_formatted.trim());


        var email = $('.step_installation [name="email"]').val();
        var phone = $('.step_installation [name="mobile"]').val();

        $.ajax({
            url: 'https://oc.smartdigitalhub.com/webapp/vxe/reservebattery/reservebattery.php?email='+email+'&phone='+phone,
            method: "POST",
            data: "",
            cache: false,
            async: true,
            success: function(data) {
            },
            progress: function(e) {
            }
        });
        
    });

    $('.step_specialist_enquiry .button_container .back').on('click', function(e){
        e.preventDefault();

        $('.step_specialist_enquiry').addClass('hidden');
        $('.step_location').removeClass('hidden');
    });

    $('.step_specialist_enquiry .button_container .continue').on('click', function(e){
        e.preventDefault();

       submitHubspotForm();

       

        $('.step_specialist_enquiry').addClass('hidden');
        $('.step_thank_you').removeClass('hidden');
    });

    
        

    $('.step_payment .payment_method').on('click', function(e){
        e.preventDefault();

        $('.step_payment .payment_method').removeClass('selected');
        $(this).addClass('selected');

        $('.step_payment .button_reserve a').removeClass('disbale');

        var payment = $(this).data('value');

        if(payment == 'brighte'){
            $('.payment_wrapper .payment_note').removeClass('hidden');
            $('.payment_wrapper .payment_note span.label span').html('Brighte');
        } else if(payment == 'plenti'){
            $('.payment_wrapper .payment_note').removeClass('hidden');
            $('.payment_wrapper .payment_note span.label span').html('Plenti');
        } else {
            $('.payment_wrapper .payment_note').addClass('hidden');
        }

        $('#ecomm_lead_payment_method-3c2f5559-981d-4e8a-ad26-0226fadf194d').val(payment.trim()).trigger('change');

    });


    $('.step_payment .button_reserve a.reserve').on('click', function(e){
        e.preventDefault();

        var product_name = $('.order_summary .product_title .name_data').html() +' '+$('.order_summary .product_title .capacity_data').html() +' '+ $('.order_summary .product_details .inverter_data').html() +' '+ $('.payment_wrapper .order_summary .product_title .ac_hybrid_data').html();

        var fullname = $('.step_installation [name="full_name"]').val();
        var email = $('.step_installation [name="email"]').val();
        var phone = $('.step_installation [name="mobile"]').val();
        var postcode = $('.check_postcode_form [name="postcode"]').val();
        var address = $('.step_installation [name="property_addres"]').val();

        var params = "?name="+fullname.trim()+"&email="+email.trim()+"&phone="+phone.trim()+"&postcode="+postcode.trim()+"&address="+address.trim()+"&productname="+product_name.trim()+'&version=2';


        window.location.href = "https://voltxenergy.com.au/ecomleadcapturereserve"+params;

        
        submitHubspotForm();
    });

    $('.step_payment .button_reserve a.back').on('click', function(e){

        e.preventDefault();

        

        $('.step_payment').addClass('hidden');
        $('.step_installation').removeClass('hidden');
    });

    

    $('.step_installation [name="full_name"], .step_installation [name="email"], .step_installation [name="mobile"], .step_installation [name="property_addres"], .step_installation [name="hear_aboutus_other"]').on('input', checkFieldsStepInstallation);
    $('.step_installation [name="installation"], .step_installation [name="hear_aboutus"]').on('change', checkFieldsStepInstallation );

    $('.step_outofstock  [name="full_name"], .step_outofstock  [name="email"], .step_outofstock  [name="mobile"], .step_outofstock  [name="property_addres"], .step_outofstock  [name="hear_aboutus_other"]').on('input', checkFieldsStepOutOfStock);
    $('.step_outofstock  [name="installation"], .step_outofstock  [name="hear_aboutus"]').on('change', checkFieldsStepOutOfStock );

    $('.step_outside_installation [name="full_name"], .step_outside_installation [name="email"], .step_outside_installation [name="mobile"], .step_outside_installation [name="property_addres"], .step_outside_installation [name="hear_aboutus_other"]').on('input', checkFieldsStepOutsideInstallation);
    $('.step_outside_installation [name="installation"], .step_outside_installation [name="hear_aboutus"]').on('change', checkFieldsStepOutsideInstallation );

    $('.step_specialist_enquiry [name="full_name"], .step_specialist_enquiry [name="email"], .step_specialist_enquiry [name="mobile"], .step_specialist_enquiry [name="property_addres"], .step_specialist_enquiry [name="hear_aboutus_other"]').on('input', checkFieldsSpecialEnquiry);
    $('.step_specialist_enquiry [name="installation"], .step_specialist_enquiry [name="hear_aboutus"]').on('change', checkFieldsSpecialEnquiry );

    $('.step_outside_installation [name="hear_aboutus"]').on('change', function(){
        var field_this = $(this);

        if(field_this.val() == 'Other'){
            $('.step_outside_installation  .hear_aboutus_other_field').removeClass('hidden');
        } else {
            $('.step_outside_installation .hear_aboutus_other_field').addClass('hidden');
            $('.step_outside_installation [name="hear_aboutus_other"]').val('');
        }
    });

    $('.step_outofstock [name="hear_aboutus"]').on('change', function(){
        var field_this = $(this);

        if(field_this.val() == 'Other'){
            $('.step_outofstock  .hear_aboutus_other_field').removeClass('hidden');
        } else {
            $('.step_outofstock .hear_aboutus_other_field').addClass('hidden');
            $('.step_outofstock [name="hear_aboutus_other"]').val('');
        }
    });

    $('.step_specialist_enquiry [name="hear_aboutus"]').on('change', function(){
        var field_this = $(this);

        if(field_this.val() == 'Other'){
            $('.step_specialist_enquiry  .hear_aboutus_other_field').removeClass('hidden');
        } else {
            $('.step_specialist_enquiry .hear_aboutus_other_field').addClass('hidden');
            $('.step_specialist_enquiry [name="hear_aboutus_other"]').val('');
        }
    });

    $('.step_installation [name="hear_aboutus"]').on('change', function(){
        var field_this = $(this);

        if(field_this.val() == 'Other'){
            $('.step_installation  .hear_aboutus_other_field').removeClass('hidden');
        } else {
            $('.step_installation .hear_aboutus_other_field').addClass('hidden');
            $('.step_installation [name="hear_aboutus_other"]').val('');
        }
    });


    // window.onload = initAutocomplete;

    
    setTimeout(() => {
        initAutocomplete('input_address_1');
        initAutocomplete('input_address_2');
        initAutocomplete('input_address_3');
    }, 500);

});

function checkFieldsSpecialEnquiry() {
    let isValid = true;

    $('.step_specialist_enquiry [name="full_name"], .step_specialist_enquiry [name="email"], .step_specialist_enquiry [name="mobile"], .step_specialist_enquiry [name="property_addres"], .step_specialist_enquiry [name="installation"], .step_specialist_enquiry [name="hear_aboutus"], .step_specialist_enquiry [name="hear_aboutus_other"]').each(function() {
        var field_this = $(this);

        if(field_this.attr('name') == 'hear_aboutus_other'){
            var hearAbout  = $('.step_specialist_enquiry [name="hear_aboutus"]').val()

            if (hearAbout.trim() === 'Other' && field_this.val().trim() === '') {
                isValid = false;
            }
        } else {
            if (field_this.val().trim() === '') {
                isValid = false;
            }
        }

        populateHubsPotForm('Specialist enquiry', field_this);
        
    });

    if(isValid){
        $('.step_specialist_enquiry .button_container a.continue').removeClass('disable');
    } else {
        $('.step_specialist_enquiry .button_container a.continue').addClass('disable');
    }

}

function checkFieldsStepOutsideInstallation() {
    let isValid = true;

    $('.step_outside_installation [name="full_name"], .step_outside_installation [name="email"], .step_outside_installation [name="mobile"], .step_outside_installation [name="property_addres"], .step_outside_installation [name="installation"], .step_outside_installation [name="hear_aboutus"], .step_outside_installation [name="hear_aboutus_other"]').each(function() {

        var field_this = $(this);

        if(field_this.attr('name') == 'hear_aboutus_other'){
            var hearAbout  = $('.step_outside_installation [name="hear_aboutus"]').val()

            if (hearAbout.trim() === 'Other' && field_this.val().trim() === '') {
                isValid = false;
            }
        } else {
            if (field_this.val().trim() === '') {
                isValid = false;
            }
        }
        
        populateHubsPotForm('Outside install area', field_this);

    });

    if(isValid){
        $('.step_outside_installation .button_container a.continue').removeClass('disable');
    } else {
        $('.step_outside_installation .button_container a.continue').addClass('disable');
    }

}



function checkFieldsStepOutOfStock() {
    let isValid = true;

    $('.step_outofstock  [name="full_name"], .step_outofstock  [name="email"], .step_outofstock  [name="mobile"], .step_outofstock  [name="property_addres"], .step_outofstock  [name="installation"], .step_outofstock  [name="hear_aboutus"], .step_outofstock  [name="hear_aboutus_other"]').each(function() {

        var field_this = $(this);

        if(field_this.attr('name') == 'hear_aboutus_other'){
            var hearAbout  = $('.step_outofstock [name="hear_aboutus"]').val()

            if (hearAbout.trim() === 'Other' && field_this.val().trim() === '') {
                isValid = false;
            }
        } else {
            if (field_this.val().trim() === '') {
                isValid = false;
            }
        }
        
        populateHubsPotForm('Out of Stock', field_this);

    });

    if(isValid){
        $('.step_outofstock  .button_container a.continue').removeClass('disable');
    } else {
        $('.step_outofstock  .button_container a.continue').addClass('disable');
    }

}



function checkFieldsStepInstallation() {
    let isValid = true;

    $('.step_installation [name="full_name"], .step_installation [name="email"], .step_installation [name="mobile"], .step_installation [name="property_addres"], .step_installation [name="installation"], .step_installation [name="hear_aboutus"], .step_installation [name="hear_aboutus_other"]').each(function() {
        var field_this = $(this);

        if(field_this.attr('name') == 'hear_aboutus_other'){
            var hearAbout  = $('.step_installation [name="hear_aboutus"]').val()

            if (hearAbout.trim() === 'Other' && field_this.val().trim() === '') {
                isValid = false;
            }
        } else {
            if (field_this.val().trim() === '') {
                isValid = false;
            }
        }
        
        populateHubsPotForm('Payment', field_this);
    });

    if(isValid){
        $('.step_installation .button_container a.continue').removeClass('disable');
    } else {
        $('.step_installation .button_container a.continue').addClass('disable');
    }

}

function submitHubspotForm(){

    var formExist_2= false;
    var existForm_2 = setInterval(function() {        
        if (!formExist_2 &&  $('#hsForm_3c2f5559-981d-4e8a-ad26-0226fadf194d').length > 0) {
        formExist_1 = true;
        
        $('.hubspot_form form.hs-form .hs_submit.hs-submit .actions .hs-button').trigger('click');
        
        clearInterval(existForm_2);
        }
    }, 300);
}

function populateHubsPotForm(enquiry_type, field_this){
    var formExist_1 = false;
    var existForm_1 = setInterval(function() {        
        if (!formExist_1 &&  $('#hsForm_3c2f5559-981d-4e8a-ad26-0226fadf194d').length > 0) {
        formExist_1 = true;

        $('#ecomm_ver_2-3c2f5559-981d-4e8a-ad26-0226fadf194d').prop('checked', true).trigger('change');
        
        if (field_this.attr('name') === 'full_name') {
            $('#full_name-3c2f5559-981d-4e8a-ad26-0226fadf194d').val(field_this.val().trim()).trigger('change');
        }

        if (field_this.attr('name') === 'email') {
            $('#email-3c2f5559-981d-4e8a-ad26-0226fadf194d').val(field_this.val().trim()).trigger('change');

            if( field_this.val().trim() == ''){
                $('.form_details_container input[name="email"]').parent().find('.hs-error-msgs').remove();
            } else {

                $('.form_details_container input[name="email"]').parent().find('.hs-error-msgs').remove();

                setTimeout(function() {
                    if( $('.hs-form .hs_email ul.no-list.hs-error-msgs li .hs-error-msg').length > 0 ){

                        if( $('.form_details_container input[name="email"]').parent().find('.hs-error-msgs').length === 0 ){
                            $('.form_details_container input[name="email"]').parent().append('<div class="hs-error-msgs">'+ $('.hs-form .hs_email ul.no-list.hs-error-msgs li .hs-error-msg').html() +'</div>');
                            $('.button_container a.continue').addClass('disable');
                        }

                    } else {
                        $('.form_details_container input[name="email"]').parent().find('.hs-error-msgs').remove();
                    }
                }, 1000);
            }
            
            
        }

        if (field_this.attr('name') === 'mobile') {
            $('#mobilephone-3c2f5559-981d-4e8a-ad26-0226fadf194d').val(field_this.val().trim()).trigger('change');

            $('.form_details_container input[name="mobile"]').parent().find('.hs-error-msgs').remove();

            if( field_this.val().trim() == ''){
                $('.form_details_container input[name="mobile"]').parent().find('.hs-error-msgs').remove();
            } else {
                var isValid = isValidAustralianMobile(field_this.val().trim());
                if(!isValid ){
                    if( $('.form_details_container input[name="mobile"]').parent().find('.hs-error-msgs').length === 0 ){
                        $('.form_details_container input[name="mobile"]').parent().append('<div class="hs-error-msgs">Please enter a valid Australian mobile number.</div>');
                        $('.button_container a.continue').addClass('disable');
                    } else {
                        $('.form_details_container input[name="mobile"]').parent().find('.hs-error-msgs').remove();
                    }
                }
            }
            
        }

        if (field_this.attr('name') === 'property_addres') {
            $('#address-3c2f5559-981d-4e8a-ad26-0226fadf194d').val(field_this.val().trim()).trigger('change');
        }

        if (field_this.attr('name') === 'installation') {
            $('#install_time_frame-3c2f5559-981d-4e8a-ad26-0226fadf194d').val(field_this.val().trim()).trigger('change');
        }

        if (field_this.attr('name') === 'hear_aboutus') {
            $('#how_did_you_hear_about_us_dropdown-3c2f5559-981d-4e8a-ad26-0226fadf194d').val(field_this.val().trim()).trigger('change');
        }

        if (field_this.attr('name') === 'hear_aboutus_other') {
            $('#how_did_you_hear_about_us_others-3c2f5559-981d-4e8a-ad26-0226fadf194d').val(field_this.val().trim()).trigger('change');
        }

        $('#enquiry_type-3c2f5559-981d-4e8a-ad26-0226fadf194d').val(enquiry_type).trigger('change');

        var sel_property = $('.step_location .property_container .selection a.active').data('value');	
        var sel_solar = $('.step_location .solar_panel_container .selection a.active').data('value');
        var sel_power = $('.step_location .power_container .selection a.active').data('value');

        var name_product = $('.step_battery .battery_content_wrapper .battery_container.selected .capacity_kwh .name_product').html();
        var name_capacity = $('.step_battery .battery_content_wrapper .battery_container.selected .capacity_kwh .name_capacity').html();
        var name_inverter = $('.step_battery .battery_content_wrapper .battery_container.selected .capacity_kwh .name_inverter').html();
        var name_ac_hybrid = $('.step_battery .battery_content_wrapper .battery_container.selected .capacity_kwh .ac_hybrid').html();

        $('#property-3c2f5559-981d-4e8a-ad26-0226fadf194d').val(sel_property).trigger('change');
        $('#solar_panel-3c2f5559-981d-4e8a-ad26-0226fadf194d').val(sel_solar).trigger('change');
        $('#power-3c2f5559-981d-4e8a-ad26-0226fadf194d').val(sel_power).trigger('change');

        if (
            typeof name_product !== 'undefined' && name_product !== null && name_product.trim() !== '' &&
            typeof name_capacity !== 'undefined' && name_capacity !== null && name_capacity.trim() !== '' &&
            typeof name_inverter !== 'undefined' && name_inverter !== null && name_inverter.trim() !== ''
        ) {
            // $('#product-3c2f5559-981d-4e8a-ad26-0226fadf194d').val(name_product +' '+ name_capacity +' '+ name_inverter ).trigger('change');
            $('#battery_reserve_product-3c2f5559-981d-4e8a-ad26-0226fadf194d').val(name_product +' '+ name_capacity +' '+ name_inverter+' '+ (name_ac_hybrid || '').trim() ).trigger('change');
        }

        
        var postcode = $('.check_postcode_form [name="postcode"]').val();
        $('#zip-3c2f5559-981d-4e8a-ad26-0226fadf194d').val(postcode).trigger('change');
        
        clearInterval(existForm_1);
        }
    }, 300);
}

function lookupPostcode(pc) {
  const n = parseInt(pc, 10);
  if (isNaN(n)) return { state: null, serviceable: false, outofstock: false };
  if ((n >= 2000 && n <= 2599) || (n >= 2619 && n <= 2899) || (n >= 2921 && n <= 2999)) return { state: "NSW", serviceable: true, outofstock: false };
  if ((n >= 3000 && n <= 3999) || (n >= 8000 && n <= 8999)) return { state: "VIC", serviceable: false, outofstock: true };
  if ((n >= 4000 && n <= 4999) || (n >= 9000 && n <= 9999)) return { state: "QLD", serviceable: true, outofstock: true };
  if (n >= 5000 && n <= 5999) return { state: "SA", serviceable: false, outofstock: false };
  if (n >= 6000 && n <= 6999) return { state: "WA", serviceable: true, outofstock: true };
  if (n >= 7000 && n <= 7999) return { state: "TAS", serviceable: false, outofstock: false };
  return { state: null, serviceable: false, outofstock: false };
}

function checkLocation(){
    if( $('.property_container .selection a.active').length > 0 && $('.power_container .selection a.active').length > 0 && $('.solar_panel_container .selection a.active').length > 0 ){
        $('.step_location .button_container a.see_batteries').removeClass('disable');
        $('.step_location .button_container a.continue').removeClass('disable');
    } else {
        $('.step_location .button_container a.see_batteries').addClass('disable');
        $('.step_location .button_container a.continue').addClass('disable');
    }
}

function checkQLD(){
    if( $('.power_container .selection a.active').length > 0 && $('.property_container .selection a.active').length > 0 ){

        var input_val = $('.check_postcode_wrapper .check_postcode_form input').val();
        var result = lookupPostcode(input_val);
        var sel_power = $('.power_container .selection a.active').data('value');
        var sel_property = $('.property_container .selection a.active').data('value');

        if( result.state == 'QLD' ){

            if( sel_power == 'Three-phase' && sel_property == 'House' ){
                $('.step_location .button_container a.see_batteries').addClass('hidden');
                $('.step_location .button_container a.continue').addClass('hidden');
                $('.step_location .button_container a.continue.unserviceable').removeClass('hidden');
            } else if(sel_property != 'House') {
                $('.step_location .button_container a.see_batteries').addClass('hidden');
                $('.step_location .button_container a.continue').removeClass('hidden');
                $('.step_location .button_container a.continue.unserviceable').addClass('hidden');
            } else {
                $('.step_location .button_container a.see_batteries').removeClass('hidden');
                $('.step_location .button_container a.continue').addClass('hidden');
            }

        } else {
            if(sel_property != 'House') {
                $('.step_location .button_container a.see_batteries').addClass('hidden');
                $('.step_location .button_container a.continue').removeClass('hidden');
                $('.step_location .button_container a.continue.unserviceable').addClass('hidden');
            } else {
                $('.step_location .button_container a.see_batteries').removeClass('hidden');
                $('.step_location .button_container a.continue').addClass('hidden');
            }
        }
        
    }
}

function calcConfidence() {
    let score = 70;

    var sel_property = $('.step_location .property_container .selection a.active').data('value');
    if( sel_property == "House") score += 10;

    var sel_solar = $('.step_location .solar_panel_container .selection a.active').data('value');
    if (sel_solar === "Yes") score += 10;
    if (sel_solar === "Planning to add") score -= 5;

    var sel_power = $('.step_location .power_container .selection a.active').data('value');
    if (sel_power === "Single-phase") score += 5;
    if (sel_power === "Three-phase") score += 5;
    if (sel_power === "Not sure") score += 0;

    return Math.max(50, Math.min(95, score));
}

function initAutocomplete(address_id) {
    const input = document.getElementById(address_id);

    // Enable Google Places Autocomplete
    const autocomplete = new google.maps.places.Autocomplete(input, {
        types: ["address"],
        componentRestrictions: { country: "au" } // Restrict to Australia
    });

    autocomplete.addListener("place_changed", function () {
        const place = autocomplete.getPlace();
    });
}